import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Transactions/Consolidate";
import Navbar from "../../Components/Navbar";
import { toast } from "react-toastify";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import EditTransactionModel from "../../Components/Transactions/EditTransactions";
import ViewDetailModel from "../../Components/Transactions/ViewDetails";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";

const Consolidate = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  // const [filter, setFilter] = useState("phone");


  const [option ,setOption] = useState("phone");
  const [editUser, setEditUser] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const { t, i18n } = useTranslation();


  const fetchFunction = async () => {
    const body = new FormData();

    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterType", option);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/getconsolidate`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading: isLoading,
    mutate: getTransactionMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

    useEffect(() => {
      const handler = setTimeout(() => {
        getTransactionMutate();
      }, 500);
  
      return () => {
        clearTimeout(handler);
      };
    }, [filterValue, startDate, endDate]);
    const apiData = data?.data?.data || [];
  
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Consolidate Amount")}
                <span>{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>
          {viewDetail && (
            <ViewDetailModel
              setViewDetail={setViewDetail}
              selectedData={selectedData}
            />
          )}

          {/* {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={error ? [] : data?.data?.data}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )} */}
          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                setEditUser={setEditUser}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />

              {error || apiData.length === 0 && <NotFoundModel />}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default Consolidate;